export default __webpack_public_path__ + "static/media/minusSignIcon.c1a7aa91.svg";